<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user-plus" style="font-size: 22px;"></i>
            </div>
            <div class="text-white">
              <h4 class="mb-0 font-weight-bold">Add Client</h4>
              <small style="opacity: .8;">Register a new enrollee under this agency</small>
            </div>
          </div>
        </div>
      </div>
      <section class="pull-up">
        <div class="container">
          <AddClientForm />
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import AddClientForm from "@/views/clients/AddClientForm.vue";

export default {
  components: {
    Navbar,
    AddClientForm,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      states: "",
      providers: "",
      clients: "",
      mdas: "",
      sector: "",
      response: "",
      state: "",
      lga_states: "",
      wards: [],
    };
  },
  beforeMount() {},
  methods: {},
  created() {},
};
</script>
